import { ChangeEvent, EventHandler, useCallback, KeyboardEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useAccountListSearch = ({
  queryParams,
  setQueryParams
}: {
  queryParams: { search?: string | null }
  setQueryParams: (params: { search?: string | null }) => void
}) => {
  const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState<string>(queryParams?.search || '')
  const [searchInputStatusMessage, setSearchInputStatusMessage] = useState<string | undefined>(undefined)

  useEffect(() => {
    setSearchValue(queryParams?.search || '')
  }, [queryParams?.search])

  const handleKeyChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setSearchValue(value)

    if ((value?.length === 0 || value?.length > 2) && setSearchInputStatusMessage) {
      setSearchInputStatusMessage(undefined)
    }
  }

  const handleKeyPress: EventHandler<KeyboardEvent<HTMLInputElement>> = useCallback(
    event => {
      if (event.key === 'Enter' && searchValue?.length > 0 && searchValue?.length < 3) {
        setSearchInputStatusMessage(t('typography.searchWithMinimum3Characters'))
      }

      if (event.key === 'Enter' && (searchValue?.length === 0 || searchValue?.length > 2)) {
        setQueryParams?.({
          search: (event.target as HTMLInputElement).value.trim()
        })
      }
    },
    [searchValue?.length, setQueryParams, t]
  )

  const handleClearValue = useCallback(() => {
    setSearchValue('')
    setQueryParams?.({ search: undefined })
    setSearchInputStatusMessage(undefined)
  }, [setQueryParams])

  return {
    searchValue,
    handleKeyChange,
    handleKeyPress,
    handleClearValue,
    searchInputStatusMessage
  }
}
